<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span class="h4 my-0">EJECUCIÓN DE RECURSOS</span>

        <div style="max-width: 200px">
          <v-select
            :items="itemsTiposTransferencia"
            label="Tipo Transfencia"
            item-text="text"
            item-value="value"
            v-model="tipoSolicitud"
            outlined
            dense
            hide-details
            @change="cambiarFiltroEstadoSolicitud" />
        </div>

        <div class="d-flex flex-wrap align-center">
          <div>
            <v-pagination
              class="custom-pagination"
              v-model="pagina"
              :length="metadatos?.total_paginas"
              :total-visible="10"
              @input="listar"></v-pagination>
          </div>

          <div style="max-width: 150px">
            <v-select
              :items="[10, 25, 50, 75, 100]"
              label="Items por página"
              v-model="limite"
              outlined
              dense
              hide-details
              :disabled="items.length == 0"
              @change="cambiarPagina" />
          </div>
        </div>
      </div>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="4" lg="3">
        <v-btn small class="mx-1" :disabled="item == null" @click="$refs.modalVisualizarSolicitud.abrir(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          small
          class="mx-1"
          :disabled="deshabilitarBotonAprobar"
          @click="$refs.modalFormSolicitudTransferencia.abrirModal('verificar', item)">
          <v-icon>mdi-list-status</v-icon>
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          small
          class="mx-1"
          :disabled="deshabilitarBotonDesembolsar"
          @click="$refs.desembolsarRef.abrirModal(item)">
          <v-icon>mdi-cash-multiple</v-icon>
        </v-btn>

        <v-btn small class="mx-1" :disabled="item == null" :loading="cargandoVerPdf" @click="verPdf(item.id)">
          <v-icon>mdi-printer</v-icon>
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          small
          class="mx-1"
          :disabled="deshabilitarBotonRegistrarPagos"
          @click="$refs.modalFormSolicitudTransferencia.abrirModal('verificar', item)">
          <v-icon>mdi-cash</v-icon>
        </v-btn>

        <v-btn small class="mx-1" @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="4" lg="3">
        <v-menu
          ref="menuFechaDeSolicitud"
          v-model="menuFechaDeSolicitud"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="rangoFechas"
              label="Fecha de Solicitud"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              clearable
              hide-details
              v-bind="attrs"
              v-on="on"></v-text-field>
          </template>

          <v-date-picker
            v-model="rangoFechas"
            no-title
            scrollable
            range
            locale="es-ES"
            :max="fechaDeHoy()"
            @input="rangoFechas.length == 2 && listarRestableciendoPagina()">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFechaDeSolicitud = false"> Cancelar </v-btn>
            <v-btn text color="primary" @click="$refs.menuFechaDeSolicitud.save(rangoFechas)"> Aceptar </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="4" lg="2">
        <v-select
          :items="itemsFiltroEstadoSolicitud"
          label="Estado Solicitud"
          item-text="text"
          item-value="value"
          v-model="estado"
          outlined
          dense
          hide-details
          @change="cambiarFiltroEstadoSolicitud" />
      </v-col>

      <v-col cols="12" md="9" lg="4">
        <v-combobox
          v-model="estadosSeleccionadosDetalleSolicitud"
          :items="itemsFiltroEstadoDetalleSolicitud"
          label="Estado Detalle Solicitud"
          dense
          clearable
          multiple
          hide-details
          outlined>
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              class="my-2"
              x-small
              v-bind="attrs"
              :color="obtenerColorEstadoDetalleSolicitud(item)"
              text-color="white"
              :input-value="selected"
              close
              @click="select"
              @click:close="removerEstadoSeleccionado(item)">
              <strong>{{ item }}</strong>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="12" md="3" lg="2">
        <v-select
          :items="unidadesNegocioFiltradas"
          label="Unidad de Negocio"
          item-text="nombre"
          item-value="id"
          v-model="unidadNegocioId"
          outlined
          dense
          hide-details
          :clearable="unidadesNegocioFiltradas.length == unidadesNegocio.length"
          @change="listarRestableciendoPagina" />
      </v-col>

      <v-col cols="12" md="6" lg="5">
        <v-btn small class="mx-1" :disabled="items.length == 0" :loading="cargandoVerPdfTodos" @click="verPdfTodos">
          <v-icon>mdi-printer</v-icon>
          Todos
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          :disabled="items.length == 0"
          small
          class="mx-1"
          :loading="cargandoVerPdfTodosConsolidadoSubtotales"
          @click="verPdfTodosConsolidadoSubtotales">
          <v-icon>mdi-printer</v-icon>
          Consolidado
        </v-btn>

        <v-btn
          v-if="permisosPresupuestos2"
          :disabled="items.length == 0"
          small
          class="mx-1"
          :loading="cargandoVerPdfTodosConsolidadoPorCuentaOrigen"
          @click="verPdfTodosConsolidadoPorCuentaOrigen">
          <v-icon>mdi-printer</v-icon>
          C. C. Origen
        </v-btn>

        <v-btn v-if="permisosPresupuestos2" small class="mx-1" @click="abrirModalGenerarReporteConciliacion">
          <v-icon>mdi-open-in-app</v-icon>
          Conciliación
        </v-btn>
      </v-col>

      <v-col cols="12" md="2" lg="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQueryBack"></v-text-field>
      </v-col>

      <v-col cols="12" md="4" lg="3">
        <v-menu
          ref="menuFechaDeDesembolso"
          v-model="menuFechaDeDesembolso"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          :disabled="deshabilitadoRangoFechasDesembolso"
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="rangoFechasDesembolso"
              label="Fecha de Desembolso"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              clearable
              hide-details
              :disabled="deshabilitadoRangoFechasDesembolso"
              v-bind="attrs"
              v-on="on"></v-text-field>
          </template>

          <v-date-picker
            v-model="rangoFechasDesembolso"
            no-title
            scrollable
            range
            locale="es-ES"
            :max="fechaDeHoy()"
            @input="rangoFechasDesembolso.length == 2 && listarRestableciendoPagina()">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFechaDeDesembolso = false"> Cancelar </v-btn>
            <v-btn text color="primary" @click="$refs.menuFechaDeDesembolso.save(rangoFechasDesembolso)">
              Aceptar
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12">
        <ListadoSolicitudTransferencias
          ref="listadoRef"
          :items="items"
          :cargando="cargando"
          :sumasTotales="metadatos?.sumas_totales"
          @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormSolicitudTransferencia ref="modalFormSolicitudTransferencia" @actualizarListado="listar">
    </ModalFormSolicitudTransferencia>

    <ModalVisualizarSolicitud ref="modalVisualizarSolicitud"> </ModalVisualizarSolicitud>

    <notifications group="notifications" position="top right" />

    <ModalDesembolsar
      ref="desembolsarRef"
      :tipo="tipo"
      @actualizar="listar"
      @cambiarTipoDesembolsos="cambiarTipoDesembolsos">
    </ModalDesembolsar>

    <VerPdf ref="verPdf" :fnDescarga="fnDescarga" @cerradoModal="fnDescarga = null" />

    <v-dialog v-model="mostradoGenerarConciliacion" max-width="600" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Generar Reporte para Conciliación</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text style="min-height: 200px">
          <v-form>
            <v-row>
              <v-col class="mt-3" cols="12">
                <vue-select
                  class="mini-select"
                  v-model="sedeSeleccionada"
                  placeholder="Seleccione Sede Origen"
                  label="nombre"
                  :clearable="false"
                  @input="obtenerCuentas"
                  :options="sedesItems">
                  <template #option="{ nombre, origen }">
                    <span style="display: block; font-size: 0.925rem">{{ nombre }}</span>
                    <small>{{ origen.toUpperCase() }}</small>
                  </template>
                </vue-select>
              </v-col>

              <v-col cols="12">
                <v-menu
                  ref="menuFechaDeDesembolsoReporteConciliacion"
                  v-model="menuFechaDeDesembolsoReporteConciliacion"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="rangoFechasDesembolsoReporteConciliacion"
                      label="Fecha de Desembolso"
                      readonly
                      outlined
                      dense
                      clearable
                      hide-details
                      v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="rangoFechasDesembolsoReporteConciliacion"
                    no-title
                    scrollable
                    range
                    locale="es-ES"
                    :max="fechaDeHoy()">
                    <v-spacer></v-spacer>

                    <v-btn text color="primary" @click="menuFechaDeDesembolsoReporteConciliacion = false">
                      Cancelar
                    </v-btn>

                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.menuFechaDeDesembolsoReporteConciliacion.save(rangoFechasDesembolsoReporteConciliacion)
                      ">
                      Aceptar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col class="mt-3" cols="12">
                <v-select
                  :items="cuentasComoItems"
                  label="Cuentas Como"
                  item-text="text"
                  item-value="value"
                  v-model="formConciliacion.cuenta_como"
                  outlined
                  dense
                  hide-details />
              </v-col>

              <v-col class="mt-3" cols="12">
                <v-combobox
                  v-model="cuentasSeleccionadas"
                  :disabled="!sedeSeleccionada"
                  :items="cuentasItems"
                  label="Cuentas"
                  clearable
                  multiple
                  hide-details
                  outlined>
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      class="d-flex flex-column"
                      v-bind="attrs"
                      text-color="white"
                      :input-value="selected"
                      close
                      small
                      color="primary"
                      @click="select"
                      @click:close="removerCuentaSeleccionada(item)">
                      <span>{{ item.nro }}</span>
                      <strong>&nbsp;-&nbsp;{{ item.nombre }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="p-4">
          <v-btn class="mb-4" color="blue darken-1" text @click.prevent="cerrarModalReporteConciliacion">
            Cerrar
          </v-btn>

          <v-btn
            v-if="permisosPresupuestos2"
            :disabled="deshabilitadoBotonGenerarReporteConciliacion"
            small
            class="mr-2 mb-4"
            @click="verPdfReporteConciliacion">
            <v-icon>mdi-printer</v-icon>
            Generar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ListadoSolicitudTransferencias from '../views/ListadoSolicitudTransferencias.vue';
import ModalFormSolicitudTransferencia from '../components/ModalFormSolicitudTransferencia.vue';
import solicitudRecursosMixin from '../mixins/solicitud-recursos-mixin';
import moment from 'moment';
import { ESTADOS_DETALLE_SOLICITUD, ESTADOS_SOLICITUD, TIPOS_SOLICITUD } from '../utils';
import ModalDesembolsar from '../components/ModalDesembolsar.vue';
import ModalVisualizarSolicitud from '../components/ModalVisualizarSolicitud.vue';

export default {
  name: 'SolicitudTransferencias',
  mixins: [solicitudRecursosMixin],
  components: {
    ListadoSolicitudTransferencias,
    ModalFormSolicitudTransferencia,
    ModalDesembolsar,
    ModalVisualizarSolicitud,
  },
  data() {
    return {
      tipo: 'todos',
      estado: localStorage.getItem('estadoSolicititudTransferencias') || ESTADOS_SOLICITUD.TODOS,
      estadosSeleccionadosDetalleSolicitud: JSON.parse(
        localStorage.getItem('estadosSeleccionadosDetalleSolicitudTransferencias'),
      ) || [ESTADOS_DETALLE_SOLICITUD.PENDIENTE],
      itemsTiposTransferencia: [
        { text: 'Todos', value: 'todos' },
        {
          text: `${TIPOS_SOLICITUD.RECURSOS[0].toUpperCase()}${TIPOS_SOLICITUD.RECURSOS.substring(1)}`,
          value: TIPOS_SOLICITUD.RECURSOS,
        },
        {
          text: `${TIPOS_SOLICITUD.GASTOS[0].toUpperCase()}${TIPOS_SOLICITUD.GASTOS.substring(1)}`,
          value: TIPOS_SOLICITUD.GASTOS,
        },
      ],
      tipoSolicitud: localStorage.getItem('tipoSolicitud') || 'todos',
      tipoSolicitudRecursos: TIPOS_SOLICITUD.RECURSOS,
    };
  },
  watch: {
    '$store.state.CARGO.sede.id'() {
      this.listarRestableciendoPagina();
    },
    estadosSeleccionadosDetalleSolicitud(value) {
      localStorage.setItem('estadosSeleccionadosDetalleSolicitudTransferencias', JSON.stringify(value));

      this.listarRestableciendoPagina();
    },
  },
  methods: {
    obtenerParametros() {
      this.establecerRangoFechasConsulta();
      this.establecerRangoFechasConsultaDesembolso();

      let sedesIds;

      if (this.unidadNegocioId) {
        if (this.sedesSeleccionadasIds.length == 0) {
          sedesIds = [-1];
        } else {
          sedesIds = this.sedesSeleccionadasIds;
        }
      } else {
        sedesIds = null;
      }

      return {
        tipo: this.tipoSolicitud != 'todos' ? this.tipoSolicitud : null,
        estado: this.estado != ESTADOS_SOLICITUD.TODOS ? this.estado : null,
        fecha_inicio: this.fechaInicio ? moment(this.fechaInicio).format('YYYY-MM-DD') : null,
        fecha_fin: this.fechaFin ? moment(this.fechaFin).format('YYYY-MM-DD') : null,
        estados_detalle_solicitud: this.estadosSeleccionadosDetalleSolicitud,
        fecha_inicio_desembolso:
          !this.deshabilitadoRangoFechasDesembolso && this.fechaInicioDesembolso
            ? moment(this.fechaInicioDesembolso).format('YYYY-MM-DD')
            : null,
        fecha_fin_desembolso:
          !this.deshabilitadoRangoFechasDesembolso && this.fechaFinDesembolso
            ? moment(this.fechaFinDesembolso).format('YYYY-MM-DD')
            : null,
        sedes_ids: sedesIds,
        limite: this.limite,
        pagina: this.pagina,
        buscar: this.searchQuery,
      };
    },
    async listar() {
      const params = this.obtenerParametros();

      await this.listarMixin(params);
    },
    cambiarFiltroEstadoSolicitud() {
      localStorage.setItem('estadoSolicititudTransferencias', this.estado);
      localStorage.setItem('tipoSolicitud', this.tipoSolicitud);

      this.listarRestableciendoPagina();
    },
    cambiarTipoDesembolsos(tipoDesembolso) {
      this?.item?.detalle_solicitud.forEach((detalle) => {
        detalle.tipo_desembolso = tipoDesembolso;
      });
    },
    async verPdfTodos() {
      const params = this.obtenerParametros();

      await this.verPdfTodosMixin(params);
    },
    async verPdfTodosConsolidado() {
      const params = this.obtenerParametros();

      await this.verPdfTodosConsolidadoMixin(params);
    },
    async verPdfTodosConsolidadoSubtotales() {
      const params = this.obtenerParametros();

      await this.verPdfTodosConsolidadoSubtotalesMixin(params);
    },
    async verPdfTodosConsolidadoPorCuentaOrigen() {
      const params = this.obtenerParametros();

      await this.verPdfTodosConsolidadoPorCuentaOrigenMixin(params);
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .custom-pagination .v-pagination__item,
::v-deep .custom-pagination .v-pagination__navigation {
  height: 28px;
  min-width: 28px;
  margin: 0px 4px;
}

::v-deep .v-btn:not(.v-btn--round).v-size--small {
  min-width: 40px;
  padding: 0 6px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

@media (max-width: 1264px) {
  .margen-top {
    margin-top: 6px !important;
  }
}

/* v-date-picker */
::v-deep .accent {
  background-color: #005caf !important;
  border-color: #005caf !important;
}
</style>

<style>
.mini-select .vs__dropdown-menu {
  max-height: 200px !important;
}
</style>
